<script setup>
import { ref,reactive,computed } from "vue";
let detailsShow = ref(false);
const props = defineProps({
    data:{},
    type:null,
    name:'',
    btn_name:{
        type:String,
        default:'报告文件上传'
    }
});
// 拿到父级传来的数据
const model = reactive(props.data);
// const bgsc = computed(() => {
    model.fields[`${props.type}`][`bgsc`] ?"": model.fields[`${props.type}`].bgsc = {}
    model.fields[`${props.type}`][`bgsc`][`${props.name}`] ?'' :model.fields[`${props.type}`][`bgsc`][`${props.name}`]= '未操作'
    // console.log(model.fields[`${props.type}`][`bgsc`][`${props.name}`])
    // model.fields[`${props.type}`][`bgsc_${props.name}`] ?'' :model.fields[`${props.type}`][`bgsc_${props.name}`]= '未操作'
//     return model.fields[`${props.type}`][`bgsc_${props.name}`]
// });
// const bgsc = (e)=>{
//     model.fields[`${props.type}`][`bgsc`][`${props.name}`] = e
//     // model.fields[`${props.type}`][`bgsc_${props.name}`] = e
// };
const crfFields = computed(()=>{
    return model.fields[`${props.type}`].bgsc
});
</script>
<template>
    <div>
        <el-button class="blue_btn" type="primary" @click="detailsShow = true">{{props.btn_name.split('-')[0]}}</el-button>
        <!-- <p class="bgsc_title">DICOM⽂件可后期上传；</p> -->
        <el-form-item label="报告文件上传" class="not_redStar">
            <!-- <p>{{ crfFields }}</p> -->
            <!-- <p>{{ props.name }}111</p> -->
            <!-- <p>{{ crfFields }}222</p> -->
          <el-radio-group v-model="crfFields[props.btn_name]">
            <el-radio label="已完成上传" prop="已完成上传"></el-radio>
            <el-radio label="未操作" prop="未操作"></el-radio>

          </el-radio-group>
        </el-form-item>
    </div>

     <el-drawer
      v-model="detailsShow"
      title="报告文件上传说明"
      direction="rtl"
      size="100%">
      <h3>1.点击下方按钮使用百度网盘，进入百度网盘输入账号密码进行登录：</h3>
      <div class="panuser">
        <div>
            <img src="@/assets/img/panuser.png" alt="">
            <el-button class="btn"  type="primary"><a href="https://pan.baidu.com/" target="_blank" class="aaa">报告文件上传</a></el-button>
        </div>
        <img src="@/assets/img/panuser1.png" alt="">
      </div>
      
      <h3>2.找到您所属的医疗机构下的文件进行文件上传：</h3>
      <div class="pic">
        <img src="@/assets/img/allpic.png" alt="">
        <img src="@/assets/img/detail.png" alt="">
    </div>
      <h3>3.上传规则：</h3>
        <div class="text">
            <p>文件上传规则：</p>
            <p>1.文件格式建议为DICOM格式，若为其他请备注</p>
            <p>2.同一患者可能存在多部位，多次检查，筛选出所需检查，按部位时间做好备注，其他检查可上传</p>
            <p>3.检查的不同期像及不同序列建议以单独子文件保存，若区分困难建议备注</p>
            <p>4.上传前确认一下图像是否能查阅</p>
        </div>
     
        <div class="btns">
            <el-button class="btn btn1" @click="detailsShow = false">返回</el-button>
            <el-button class="btn" type="primary"><a href="https://pan.baidu.com/" target="_blank" class="aaa">报告文件上传</a></el-button>
        </div>
        
    </el-drawer>
</template>
<style lang="scss" scoped>
.bgsc_title{
    padding-left: 10px;
    color: rgb(212, 14, 14);
    font-size: 12px;
}
.panuser{
    display: flex;
    padding: 10px 20px;
    &>div{
        width: 200px;
        height: 300px;
        text-align: center;
        margin-right: 100px;
        img{
            margin:20px auto;
            width: 150px;
            height: 120px;
        }
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    img{
        width: 500px;
        height: 300px;
    }
}
.pic{
    display: flex;
    img{
        height: 200px;
    }
}
.aaa{
  text-decoration: none;
  color: white;
}
.text{
    padding-left: 20px;
}
.btns{
    .btn1{
        background-color: rgb(105, 95, 95);
        color: white;
    }
    display: flex;
    justify-content: space-evenly;
}
.btn{
        width: 200px;
        height: 50px;
    }
    .blue_btn{
        background-color: rgb(84, 84, 241);
        border: 0 solid rgb(35, 35, 239);
    }
</style>